import { Box, Fade, Flex } from '@chakra-ui/react';
import React from 'react';

import PageContext from '../../../../templates/context/PageContext';
import Brand from '../../../Brand';
import Button from '../../../Button';
import Glass from '../../../Glass';
import Link from '../../../Link';
import { useNavigation } from '../Navigation.context';
import GetStartedModal from './GetStartedModal';
import MenuButton from './Menu/Button/MenuButton';
import MainNavigationMenu from './Menu/MainNavigationMenu';

interface MainNavigationProps {}

const MainNavigation: React.FC<MainNavigationProps> = () => {
  const { main } = useNavigation();
  const slug = React.useContext(PageContext);
  const [open, setOpen] = React.useState(false);

  return (
    <Flex
      position="relative"
      zIndex={{ base: 0, laptop: 1 }}
      width="100%"
      borderBottom="1px"
      borderColor="gray.200"
      background="white"
    >
      <Flex
        left={0}
        right={0}
        direction={{ base: 'column', laptop: 'row' }}
        margin="auto"
        paddingX={{ base: '16px', lg: '32px' }}
        paddingBottom={{ base: '16px', laptop: 0 }}
        width="100%"
        maxWidth="1536px"
      >
        <Flex
          direction="row"
          justify="space-between"
          align="center"
          width="full"
          height="100%"
        >
          <Link
            to="/"
            variant="plain"
            marginY={{ base: '8px', lg: 'none' }}
            marginRight={{ laptop: '16px', lg: '24px' }}
          >
            <Brand />
          </Link>
          <Flex
            direction="column"
            width={{ laptop: 'full' }}
            justify="space-between"
          >
            {!main.active && (
              <MenuButton onClick={main.open} display={{ laptop: 'none' }} />
            )}
            <MainNavigationMenu />
            {main.active && (
              <Fade in>
                <Glass
                  display={{ base: 'block', laptop: 'none' }}
                  className="Glass_Mobile"
                  onClick={main.close}
                />
              </Fade>
            )}
          </Flex>
        </Flex>
        <Box
          display={{ base: 'flex', laptop: 'block`' }}
          order={{ base: 2, laptop: 3 }}
          flexDirection="row"
          justifyContent="space-between"
          flexGrow="1"
          flexShrink="0"
          flexBasis="auto"
        >
          {!(
            slug?.includes('/rd/') ||
            slug?.includes('/rsm/') ||
            slug?.includes('/reps/') ||
            slug?.includes('/getstarted/')
          ) && (
            <>
              <Button
                variant="solid"
                colorScheme="red"
                flexGrow={1}
                paddingX={{ laptop: 4, xl: 12 }}
                marginRight={{ base: '16px', laptop: 0 }}
                position={{ laptop: 'relative' }}
                top={{ laptop: '50%' }}
                transform={{ laptop: 'translateY(-50%)' }}
                onClick={() => setOpen(true)}
              >
                Get a Quote
              </Button>
              <GetStartedModal
                refPage={slug as string | null | undefined}
                open={open}
                onClose={() => setOpen(false)}
              />
            </>
          )}

          <Button
            variant="outline"
            colorScheme="blue"
            display={{ laptop: 'none' }}
            href="https://member.mywoodmen.org/Member/?_ga=2.203913171.213816262.1643646216-102380624.1635882099"
          >
            Sign In
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
};

export default MainNavigation;
